"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var noop = function () { };
var GhostProjectListItem = function () {
    return (react_1.default.createElement("div", { className: "project-list-item project-list-item--ghost" },
        react_1.default.createElement("div", { className: "project-list-item__left-actions" },
            react_1.default.createElement("div", { className: "project-list-item__left-actions" },
                react_1.default.createElement(kaleidoscope_1.GhostBlock, { className: "icon--ghost" }),
                react_1.default.createElement(kaleidoscope_1.GhostBlock, { className: "project-list-item__ghosted-buttons" }))),
        react_1.default.createElement("div", { className: "project-list-item__right-actions" },
            react_1.default.createElement(kaleidoscope_1.GhostBlock, { className: "project-list-item__ghosted-buttons" }),
            react_1.default.createElement("div", { className: "project-list-item__options project-list-item__options--ghost" },
                react_1.default.createElement(icons_1.OptionsVertical, null)))));
};
exports.default = GhostProjectListItem;
